import i18n from 'i18next';
import { useMemo } from 'react';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentCargoTypesPricing } from '../../hooks';

export const CargoTypePricingSelect = ({
  placeholder = i18n.t('translation:default.fields.cargoType.placeholder'),
  label = i18n.t('translation:default.fields.cargoType.label'),
  rules = [],
  name,
  editMode,
  value,
  tooltip,
  margin = 'mb-0',
  mode = '',
  onChange,
  singleLineMode = false,
}) => {
  const { data = [], isLoading } = useGetShipmentCargoTypesPricing();

  const options = useMemo(
    () =>
      data.map((row) => ({
        label: row.codeDesc,
        value: row.codeId,
      })),
    [data],
  );

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      value={value}
      tooltip={tooltip}
      mode={mode}
      onChange={onChange}
      singleLineMode={singleLineMode}
    />
  );
};
